var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-overlay", {
        attrs: {
          show: _vm.showOverlay,
          "no-wrap": "",
          "spinner-type": "grow",
          opacity: ".40",
          "spinner-variant": "primary",
          "z-index": "99999999",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c(
            "b-card",
            {
              attrs: {
                "bg-variant": "ligth",
                "text-variant": "black",
                title: _vm.$t("title"),
              },
            },
            [
              _c("b-card-text", [
                _c("span", {
                  domProps: { textContent: _vm._s(_vm.$t("description")) },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-3 float-left" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.openHome()
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "icon-inicio" }),
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(_vm.$t("error.toHomeButton")),
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.vistaPrevia(_vm.encryptedCvu)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "icon-PDF" }),
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("perfil-unico.visualizar")
                          ),
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("visualizador-pdf", {
        attrs: {
          modalId: "modalPdf",
          contenidoBase64: this.contenidoBase64,
          mostrar: this.pdfReady,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }